import React, { useEffect, useMemo, useState } from "react";
import Header from "../../Components/Header";
import "./index.scss";
import TechnicianCard from "../../Components/TechnicianCard";
import AutoSuggestInput from "../../Components/AutoSuggestInput";
import { CustomSelect } from "../../UI/Select";
import { Map } from "../../Components/Map";
import { useLoadScript } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux";
import useGetCertificates from "../../Global/Api/Dashboard/getCertificates.api";
import {setAddress, setCertificate, setCoordinates} from "../../Store/Slice/dashboardSlice";
import TechItemModal from "../../Components/Schedule/SchedulingTech/TechItemModal";
import useGetTechnicians from "../../Global/Api/Dashboard/getTechinicians.api";
import Pagination from "../../Components/Pagination";
import useGetTotalUnreadMessage from "../../Global/Api/Messaging/getTotalUnreadMessage";
import {Paginate} from "../../Components/Paginate";

export default function Dashboard() {
  const dispatch = useDispatch();
  const getCertificates = useGetCertificates();
  const [currentItem, setCurrentItem] = useState(null);
  const [page, setPage] = useState(1);
  const getTechnicians = useGetTechnicians(page);
  const [modal, setModal] = useState(false);
  const [search, setSearch] = useState("");
  const getTotalUnread = useGetTotalUnreadMessage();

  const { certificates, certificate, address, technicians_list, allTechsLocs } = useSelector(
    (state) => state?.rootReducer.dashboardSlice
  );

  const accountIndex = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBL99kJ-59bryhoVvhKkV6a2JlEFZhQG2I",
  });

  const renderTechnicians = useMemo(
    () =>
      technicians_list?.data?.map((item, index) => (
        <TechnicianCard
          key={item?.id}
          page={page}
          technician={item}
          setModal={setModal}
          setCurrentItem={setCurrentItem}
        />
      )),
    [technicians_list]
  );

  const handleModal = () => {
    setModal(!modal);
  };

  const handleSearch = (e) => {
    if (e.lat && e.lon) {
      dispatch(setCoordinates({lat: e.lat, lon: e.lon}))
    }
    if (!e?.address) {
      dispatch(setAddress(e));
    }
    setSearch(e);
  };

  useEffect(() => {
    if (accountIndex?.registration_completed) {
      getCertificates.get();
      getTechnicians.getAllTechsLocs();
      getTechnicians.get();
      if (localStorage.getItem("techsbook_customer_portal_token")?.length > 0) {
        getTotalUnread.get();
      }
    }
  }, [accountIndex]);

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"});
  }, [page])
  return (
    <>
      <Header title={"Technicians"} showFull={true} />
      <div className="technicians">
        <div className="technicians__filters">
          <div className="technicians__address">
            <span className="technicians__address-icon">
              <img src="/assets/icons/locations.svg" alt="location" />
            </span>
            <AutoSuggestInput
              address={search?.address ?? ""}
              handleAddressChange={(e) => handleSearch(e ?? null)}
              handleSelectChange={(e) =>  dispatch(setAddress(e))}
              placeholder="Enter street address"
              className=""
            />
          </div>
          <div className="technicians__select">
            <CustomSelect
              options={certificates}
              selected={certificate}
              placeholder={"Certified"}
              handleSelect={(e) => {
                dispatch(setCertificate(e ?? null));
              }}
              isClearable={true}
            />
          </div>
        </div>
        {modal && <TechItemModal item={currentItem} closeModal={handleModal} />}
        <div className="technicians__map">
          {isLoaded && (
              <Map
                  height={"340px"}
                  weight={"100%"}
                  data={(address?.address || address?.length) ? technicians_list?.data : allTechsLocs}
                  search={search}
                  zoom={(address?.address || address?.length) ? 8 : 4}
              />
          )}
        </div>
        <div className="technicians__list">
          {technicians_list?.data?.length === 0 ? (
            <div className="technicians-empty">
              <div>
                <img src="/assets/images/technicians-empty.svg" alt="" />
              </div>
              <p className="technicians-empty-text">No Technicians</p>
            </div>
          ) : (
            renderTechnicians
          )}
        </div>
        {technicians_list?.totalPage > 1 && (
          <Paginate currentPage={page} setCurrentPage={setPage} pageCount={technicians_list?.totalPage}/>
        )}
      </div>
    </>
  );
}
